<template>
<div class="col-12">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="p-2">
      <small class="text-muted">Dashboard</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
  </div>
</div>
</template>

<script>
import AppDatatable from '../components/AppDatatable.vue'
import AppChart from '../components/AppChart.vue'
import { chart, ccfLatestData, ccfLatestCustomer } from '../models/chart'
// import AppDataPagination from '../components/AppDataPagination.vue'
// import AppGoogleMaps from '../components/AppGoogleMaps.vue'
import AppNavBar from '../components/AppNavbar.vue'
// import AppGooglePlaceAutocomplete from '../components/AppGooglePlaceAutocomplete.vue'
import api from '../services/api'
import moment from 'moment'

export default {
  components: {
    AppDatatable, AppNavBar, AppChart
  },
  data() {
    return {
      cht: {...chart, ccfLatestData:[], ccfLatestCustomer: []},

      
    }
  },
  async created() {
    this.init()
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2017}, (value, index) => 2018 + index)
    }
  },
  methods: {
    async init() {
      // this.cht.firstYear = moment().format('YYYY')
      // this.cht.secondYear = this.cht.firstYear - 1
      // this.cht.module = 'Customer Complaint'

      // this.filter()
    },
    // async filter() {
    //   this.chartLoaded = false

    //   const query = {
    //     params: {
    //       firstYear: this.cht.firstYear,
    //       secondYear: this.cht.secondYear,
    //       plantDoveAndSoap: 'Dove and Soap',
    //       plantFattyAcid: 'Fatty Acid'
    //     }
    //   }

    //   const statusApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-status') : this.cht.module === 'NCR' ? api('get-ncr-by-status') : api('get-recall-by-status')
    //   const statusData = await statusApi.get()
    //   this.status = statusData

    //   const categoryApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-category') : this.cht.module === 'NCR' ? api('get-ncr-by-category') : api('get-recall-by-category')
    //   const categoryData = await categoryApi.get()
    //   this.category = categoryData

    //   const monthApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-month') : this.cht.module === 'NCR' ? api('get-ncr-by-month') : api('get-recall-by-month')
    //   const monthData = await monthApi.getWithQuery(query)
    //   this.month = monthData

    //   const plantDoveApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-plant-dns') : api('get-recall-by-plant-dns')
    //   const plantDoveData = await plantDoveApi.getWithQuery(query)
    //   this.plantDove = plantDoveData

    //   const plantFattyApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-plant-fa') : api('get-recall-by-plant-fa')
    //   const plantFattyData = await plantFattyApi.getWithQuery(query)
    //   this.plantFatty = plantFattyData

    //   const departmentApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-department') : this.cht.module === 'NCR' ? api('get-ncr-by-department') :  api('get-recall-by-department')
    //   const departmentData = await departmentApi.getWithQuery(query)
    //   this.department = departmentData

    //   const productApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-product') : api('get-recall-by-product')
    //   const productData = await productApi.getWithQuery(query)
    //   this.product = productData

    //   const ccfLatestApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-latest') : this.cht.module === 'NCR' ? api('get-ncr-by-latest') : api('get-recall-by-latest')
    //   const ccfLatestData = await ccfLatestApi.get()
    //   this.cht.ccfLatestData = ccfLatestData.data
    //   this.cht.titleTop10PerModule = ccfLatestData.title

    //   const ccfCustomerApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-latest-customer') : api('get-recall-by-latest-customer')
    //   const ccfCustomerData = await ccfCustomerApi.get()
    //   this.cht.ccfLatestCustomer = ccfCustomerData.data
    //   this.cht.titleTop10CustomerPerModule = ccfCustomerData.title

    //   this.chartLoaded = true
    // },
    selectRow(id) {
      this.selectedId = id
    },
  }  
}
</script>